import Home from "../../containers/deviceSales/index";
import ActivationSales from "../../containers/activationSales/activationSales";
import RechargeSales from "../../containers/rechargeSales/rechargeSales";
import DevicePayout from "../../containers/devicePayout/devicePayout";
import ActivationPayout from "../../containers/activationPayout";
import RechargePayout from "../../containers/rechargePayout";
import RetailerPerformance from "../../containers/retailerPerformance/index";
import MyEarnings from "../../containers/myEarnings/index";
import TokenExpired from "../../containers/tokenExpired/tokenExpired";
import UnAuthorizedUser from "../../containers/unAuthorizedUser/unAuthorizedUser";
import SessionExpired from "../../containers/sessionExpired/sessionExpired";
import OperationalDashboard from "../../containers/operationalDashboard/index";
import CustomLandingBody from "../../components/customLandingBody/index";
import WireLineJioFiber from "../../containers/wirelineJioFiber";
import EnterpriseConnectivity from "../../containers/wirelineEnterpriseConnectivity";
import Payout from "../../containers/payoutDashboard";
import SchemeOverview from "../../containers/schemeOverview";
import EdOrdersSummary from "../../containers/edOrdersSummary";
import PotentialIncentiveEarnings from "../../containers/potentialIncentiveEarnings";
import ClawbackReport from "../../containers/clawbackReport";

const operationalDashboard = [
  {
    path: "/operationalDashboard",
    path_: "/operationalDashboard",
    component: OperationalDashboard,
    group: "app entry",
    readableName: "Operational Dashboard",
    pageSubType: "Operational Dashboard",
    TrkPageFormat: "standard view",
  },
];
const potentialIncentiveEarnings = [
  {
    path: "/schemePerformance",
    path_: "/schemePerformance",
    component: PotentialIncentiveEarnings,
    group: "app entry",
    readableName: "Operational Dashboard",
    pageSubType: "Operational Dashboard",
    TrkPageFormat: "standard view",
  },
];
const token = [
  {
    path: "/",
    path_: "/",
    component: TokenExpired,
    group: "app entry",
    readableName: "Token Expire",
    pageSubType: "Display Token Expire",
    TrkPageFormat: "standard view",
  },
];
const user = [
  {
    path: "/",
    path_: "/",
    component: UnAuthorizedUser,
    group: "app entry",
    readableName: "Unauthorized User",
    pageSubType: "Display Unauthorized User",
    TrkPageFormat: "standard view",
  },
];

const session = [
  {
    path: "/sessionExpired",
    path_: "/sessionExpired",
    component: SessionExpired,
    group: "app entry",
    readableName: "Unauthorized User",
    pageSubType: "Display Unauthorized User",
    TrkPageFormat: "standard view",
  },
];
const home = [
  ...session,
  {
    path: "/",
    path_: "/",
    component: CustomLandingBody,
    group: "app entry",
    readableName: "Landing page",
    pageSubType: "Display Landing page",
    TrkPageFormat: "standard view",
  },
];
const device = [
  {
    path: "/deviceSales",
    path_: "/device",
    component: Home,
    group: "app entry",
    readableName: "Home",
    pageSubType: "Display Dashboard",
    TrkPageFormat: "standard view",
  },
];
const sales = [
  {
    path: "/rechargeSales",
    path_: "/rechargeSales",
    component: RechargeSales,
    group: "",
    readableName: "Recharge Sales",
    pageSubType: "Display Recharge Sales Details",
    TrkPageFormat: "standard view",
  },
];
const simConnectivity = [
  {
    path: "/simActivation",
    path_: "/simActivation",
    component: ActivationSales,
    group: "",
    readableName: "Activation Sales",
    pageSubType: "Display Activation Sales Details",
    TrkPageFormat: "standard view",
  },
];
const earnings = [
  {
    path: "/myEarnings",
    path_: "/myEarnings",
    component: MyEarnings,
    group: "",
    readableName: "My Earnings",
    pageSubType: "Display My Earnings Details",
    TrkPageFormat: "standard view",
  },
];
const devicePayout = [
  {
    path: "/devicePayout",
    path_: "/devicePayout",
    component: DevicePayout,
    group: "",
    readableName: "Device Payout",
    pageSubType: "Display Device Payout Details",
    TrkPageFormat: "standard view",
  },
];
const activationPayout = [
  {
    path: "/activationPayout",
    path_: "/activationPayout",
    component: ActivationPayout,
    group: "",
    readableName: "Activation Payout",
    pageSubType: "Display Activation Payout Details",
    TrkPageFormat: "standard view",
  },
];
const rechargePayout = [
  {
    path: "/rechargePayout",
    path_: "/rechargePayout",
    component: RechargePayout,
    group: "",
    readableName: "Recharge Payout",
    pageSubType: "Display Recharge Payout Details",
    TrkPageFormat: "standard view",
  },
];
const retPer = [
  {
    path: "/retailerPerformance",
    path_: "/retailerPerformance",
    component: RetailerPerformance,
    group: "",
    readableName: "Retailer Performance",
    pageSubType: "Display Retailer Performance Details",
    TrkPageFormat: "standard view",
  },
];

const wireLine = [
  {
    path: "/wirelineJioFiber",
    path_: "/wirelineJioFiber",
    component: WireLineJioFiber,
    group: "",
    readableName: "Wire Line JioFiber",
    pageSubType: "Display Wire Line JioFiber Details",
    TrkPageFormat: "standard view",
  },
];

const enterpriseConnectivity = [
  {
    path: "/wirelineEnterpriseConnectivity",
    path_: "/wirelineEnterpriseConnectivity",
    component: EnterpriseConnectivity,
    group: "",
    readableName: "Wire Line Enterprise Connectivity",
    pageSubType: "Display Wire Line Enterprise Connectivity",
    TrkPageFormat: "standard view",
  },
];

const payoutDashboardForSmbAndFiber = [
  {
    path: "/payoutDashboard",
    path_: "/payoutDashboard",
    component: Payout,
    group: "",
    readableName: "Payout dashboard for SMB and Fiber",
    pageSubType: "Display Payout dashboard for SMB and Fiber",
    TrkPageFormat: "standard view",
  },
];

const schemeOverview = [
  {
    path: "/schemeOverview",
    path_: "/schemeOverview",
    component: SchemeOverview,
    group: "",
    readableName: "Scheme Count dashboard for Mobility",
    pageSubType: "Display Scheme Count dashboard for Mobility",
    TrkPageFormat: "standard view",
  },
];

const edOrdersSummary = [
  {
    path: "/edOrdersSummary",
    path_: "/edOrdersSummary",
    component: EdOrdersSummary,
    group: "",
    readableName: "ED Orders Summary Dashboard for SMB",
    pageSubType: "Display ED Orders Summary Dashboard for SMB",
    TrkPageFormat: "standard view",
  },
];

const clawbackReport = [
  {
    path: "/partnersClawbackReport",
    path_: "/partnersClawbackReport",
    component: ClawbackReport,
    group: "app entry",
    readableName: "Partners Clawback Report",
    pageSubType: "Partners Clawback Report",
    TrkPageFormat: "standard view",
  },
];

const payouts = [
  ...devicePayout,
  ...activationPayout,
  ...rechargePayout,
  // ...user
];

const NHQ = [
  ...home,
  ...device,
  ...sales,
  ...simConnectivity,
  ...earnings,
  ...payouts,
  ...operationalDashboard,
  ...wireLine,
  ...enterpriseConnectivity,
  ...payoutDashboardForSmbAndFiber,
  ...edOrdersSummary,
  ...potentialIncentiveEarnings,
  ...clawbackReport,
  // ...otherRoutes
];

const Fiber = [
  ...wireLine,
  ...payoutDashboardForSmbAndFiber,
  ...enterpriseConnectivity,
];

const allRoutes = [...NHQ, ...retPer];
const myRoutes = {
  TOKEN_EXPIRE: token,
  UN_AUTH: user,
  SESSION_EXPIRED: session,
  NHQ: [...NHQ, ...retPer, ...schemeOverview],
  STATE: [...NHQ, ...retPer],
  REGION: [...NHQ, ...retPer],
  JC: [...NHQ, ...retPer],
  JP: [
    ...home,
    ...device,
    ...sales,
    ...simConnectivity,
    ...retPer,
    ...potentialIncentiveEarnings,
    // ...user
  ],
  AREA: [
    ...home,
    ...sales,
    ...simConnectivity,
    ...device,
    ...payouts,
    ...earnings,
    ...retPer,
    ...potentialIncentiveEarnings,
  ],
  ZD: [...NHQ],
  RDS: allRoutes,
  ARD: allRoutes,
  MARD: allRoutes,
  ZDMT: [...NHQ],
  ITZ: [...NHQ],
  ITD: [
    ...home,
    ...device,
    ...sales,
    ...simConnectivity,
    ...devicePayout,
    ...rechargePayout,
    ...earnings,
    // ...user
  ],
  END: [...NHQ],
  XG: [...home, ...payoutDashboardForSmbAndFiber, ...edOrdersSummary],
  RZD: NHQ,
  DT: [
    ...home,
    ...device,
    ...sales,
    ...activationPayout,
    // ...user
  ],
  CHAIN: [...NHQ],
  GENERAL_RETAILERS: [],
  JBA: [...home, ...Fiber],
  JBAP: [...home, ...Fiber, ...edOrdersSummary],
  J4: [...home, ...Fiber],
  DLCO: [...home, ...Fiber],
  EV: [...home, ...Fiber],
  Z8: [...home, ...Fiber],
  ET: [...home, ...Fiber],
  HSP: [...home, ...Fiber],
  DE: [...home, ...Fiber],
  DO: [...home, ...Fiber],
  DQ: [...home, ...Fiber],
  DX: [...home, ...Fiber],
  EO: [...home, ...Fiber],
  EU: [...home, ...Fiber],
  J1: [...home, ...Fiber],
  J2: [...home, ...Fiber],
  J3: [...home, ...Fiber],
  JA: [...home, ...Fiber],
  JB: [...home, ...Fiber],
  J7: [...home, ...Fiber],
  JH: [...home, ...Fiber],
  JK: [...home, ...Fiber],
  JX: [...home, ...Fiber],
  JY: [...home, ...Fiber],
  JZ: [...home, ...Fiber],
  QD: [...home, ...Fiber],
  QE: [...home, ...Fiber],
  Z7: [...home, ...Fiber],
  FTX: [...home, ...Fiber],
};

export default myRoutes;
